import actions from './actions';

const {
  PROGRESS_ADD_BEGIN,
  PROGRESS_ADD_SUCCESS,
  PROGRESS_ADD_ERR,

  GET_PROGRESS_BY_TASK_READ_BEGIN,
  GET_PROGRESS_BY_TASK_READ_SUCCESS,
  GET_PROGRESS_BY_TASK_READ_ERR,

  TODAY_PROGRESS_READ_BEGIN,
  TODAY_PROGRESS_READ_SUCCESS,
  TODAY_PROGRESS_READ_ERR,

  PROGRESS_COMMENT_ADD_BEGIN,
  PROGRESS_COMMENT_ADD_SUCCESS,
  PROGRESS_COMMENT_ADD_ERR,
} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const todayprogressinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const addinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const addCommentinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const GETProgressByTaskReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_PROGRESS_BY_TASK_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_PROGRESS_BY_TASK_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_PROGRESS_BY_TASK_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const TODAYProgressReducer = (state = todayprogressinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case TODAY_PROGRESS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case TODAY_PROGRESS_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case TODAY_PROGRESS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const PROGRESSAddReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PROGRESS_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PROGRESS_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PROGRESS_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };


    default:
      return state;
  }
};

const PROGRESSCommentAddReducer = (state = addCommentinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PROGRESS_COMMENT_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PROGRESS_COMMENT_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PROGRESS_COMMENT_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };


    default:
      return state;
  }
};

export { PROGRESSAddReducer, GETProgressByTaskReducer, TODAYProgressReducer, PROGRESSCommentAddReducer };
